import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
 
@Injectable({ providedIn: 'root' })
export class SilentRenewService {
  private intervalId: any = null;
 
  constructor(private authService: AuthService) {}
 
  startSilentRenew() {
    console.log('[SilentRenew] Starting silent renew every 15 seconds');
 
    this.intervalId = setInterval(async () => {
      try {
        const token = sessionStorage.getItem('token');
        if (!token) {
          console.warn('[SilentRenew] No token found, skipping...');
          return;
        }
 
        const decoded = JSON.parse(atob(token.split('.')[1]));
        const exp = decoded.exp;
        const now = Math.floor(Date.now() / 1000);
        const secondsLeft = exp - now;
 
        console.log(`[SilentRenew] Token expires in ${secondsLeft}s`);
 
        // Renew if expiring in next 10 mins
        if (secondsLeft < 600) {
          console.log('[SilentRenew] Token expiring soon, refreshing...');
          const refreshed = await this.authService.isTokenValid();
 
          if (refreshed) {
            console.log('[SilentRenew] Token refreshed successfully.');
          } else {
            console.warn('[SilentRenew] Token refresh failed.');
            return;
          }
        }
 
        // Decode and save accessTokenExp
        const activeToken = sessionStorage.getItem('token');
        if (activeToken) {
          const decodedActive = JSON.parse(atob(activeToken.split('.')[1]));
          sessionStorage.setItem('accessTokenExp', decodedActive.exp.toString());
          console.log(`[SilentRenew] Stored accessTokenExp=${decodedActive.exp} in sessionStorage`);
        }
 
        //Call /UserManagement/GetOrCreateUser API
        console.log('[SilentRenew] Calling /UserManagement/GetOrCreateUser...');
 
        const payload = { accessToken: activeToken };
        const user = await this.authService.callGetOrCreateUser(payload);
 
        console.log('[SilentRenew] Received user response:', user);
        sessionStorage.setItem('appUser', JSON.stringify(user));
        console.log('[SilentRenew] Stored user in sessionStorage');
 
      } catch (err) {
        console.error('[SilentRenew] Error during silent renew:', err);
      }
    }, 15000);  // Every 15 seconds
  }
 
  stopSilentRenew() {
    clearInterval(this.intervalId);
    console.log('[SilentRenew] Stopped silent renew.');
  }
}